import React, { useEffect } from "react";
import { connect, ConnectedProps } from "react-redux";
import { NavLink, RouteComponentProps, withRouter } from "react-router-dom";
import { bindActionCreators, Dispatch } from "redux";
import OutlineButton from "sweet-web/components/universal/Button/OutlineButton";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";
import { CreateVenue } from "sweet-web/redux/venue/actions";

type Props = RouteComponentProps & ConnectedProps<typeof connector>;

const CreateListing: React.FC<Props> = props => {
  const { myVenues, synced, isCreatingVenue } = props;

  const createVenue = async () => {
    const venueId = await props.CreateVenue();
    props.history.push(`/listing/${venueId}`);
  };

  useEffect(() => {
    if (Object.keys(myVenues).length === 0 && synced) {
      createVenue();
    }
  }, [synced]);

  return (
    <OutlineButton
      title="Create Listing"
      onClick={createVenue}
      loading={isCreatingVenue}
    />
  );
};

const mapState = (state: RootState) => ({
  myVenues: selectors.myVenues(state),
  isCreatingVenue: selectors.isCreatingVenue(state),
  synced: selectors.successSyncing(state)
});
const mapDispatch = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      CreateVenue
    },
    dispatch
  );
const connector = connect(mapState, mapDispatch);

export default withRouter(connector(CreateListing));
